import Icon from '../../../components/AppIcon';
import { toArabicDigits } from '../../../utils/numbers';

const StatsCard = ({ icon, label, value, trend, trendValue, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary',
    accent: 'bg-accent/10 text-accent',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning'
  };

  return (
    <div className="relative flex flex-col items-center justify-center w-48 h-48 md:w-56 md:h-56 lg:w-64 lg:h-64 rounded-full transition-all duration-300 hover:scale-105">
      <div className={`w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center ${colorClasses?.[color]} mb-3 shadow-lg`}>
        <Icon name={icon} size={24} className="md:w-7 md:h-7" />
      </div>
      {trend && (
        <div className={`absolute top-4 right-4 flex items-center gap-1 text-xs md:text-sm px-2 py-1 rounded-full ${trend === 'up' ? 'bg-success/10 text-success' : 'bg-error/10 text-error'}`}>
          <Icon name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={12} className="md:w-3 md:h-3" />
          <span className="font-medium">{toArabicDigits(trendValue)}</span>
        </div>
      )}
      <div className="text-center space-y-2">
        <p className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground">{toArabicDigits(value)}</p>
        <p className="text-xs md:text-sm text-muted-foreground px-4 font-body">{label}</p>
      </div>
    </div>
  );
};

export default StatsCard;